export default __webpack_public_path__ + "static/media/cathal.ec159863.png";